import { render } from "./IndexPartners.vue?vue&type=template&id=61d37539"
import script from "./IndexPartners.vue?vue&type=script&lang=js"
export * from "./IndexPartners.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__